<template>
	<div id="footer">
		<div class="content">
			<div class="ft_t" style="text-align:center">
				<p class="w over">
					<img src="../assets/picture/index/footer.png" width="" height="">
				</p>
			</div>
			<div class="w">
				<dl class="f_dl">
					<dt>新手上路</dt>
					<dd>
						<a href="/help/reg" style="display:block;">注册新用户</a>
						<a href="/article" style="display:block;">夜樱资讯</a>
						<a href="/help/fangshi" style="display:block;">如何订购</a>
						<a href="/help/jifen" style="display:block;">会员积分</a>
					</dd>
				</dl>
				<dl class="f_dl">
					<dt>支付方式</dt>
					<dd>
						<a href="/help/zaixian" style="display:block;">在线方式</a>
						<a href="/help/huodaofukuan" style="display:block;">货到付款</a>
						<a href="/help/youuhijuan" style="display:block;">优惠券支付</a>
						<a href="/help/jifenshiyong" style="display:block;">积分抵现</a>
					</dd>
				</dl>
				<dl class="f_dl">
					<dt>订购方式</dt>
					<dd>
						<a href="/help/dinggouliucheng" style="display:block;">网站订购</a>
						<a href="/help/dianhuadingou" style="display:block;">电话订购</a>
						<a href="/help/weixindinggou" style="display:block;">微信订购</a>
						<a href="/appdinggou" style="display:block;">APP订购</a>
					</dd>
				</dl>
				<dl class="f_dl">
					<dt>配送与售后</dt>
					<dd>
						<a href="/help/qianshou" style="display:block;">签收说明</a>
						<a href="/help/wuliu" style="display:block;">快递物流</a>
						<a href="/help/tuihuan" style="display:block;">退/换货政策</a>
						<a href="/help/yinsibaohu" style="display:block;">隐私保护</a>
					</dd>
				</dl>
				<dl class="f_dl">
					<dt>帮助中心</dt>
					<dd>
						<a href="/help/changjianwenti" style="display:block;">常见问题</a>
						<a href="/help/kefu" style="display:block;">客服中心</a>
						<a href="/help/ceomail" style="display:block;">CEO邮箱</a>
						<a href="/jiameng" style="display:block;">批发/代发</a>
					</dd>
				</dl>
				<dl class="f_dl mr0">
					<dt>
						<img src="../assets/image/bottom/microQr.png" width="100" height="100">
					</dt>
					<dd>夜樱情趣APP下载</dd>
				</dl>
				<div class="clear"></div>
			</div>
			<div class="w">
				<div style="text-align:center;background:#f00180;line-height:35px;">
					<p>
						<a href="/" class="c6">首页</a>
						<span class="vline">|</span>
						<a href="/safes" class="c6">正品,隐私保障</a>
						<span class="vline">|</span>
						<a href="/help" class="c6">帮助中心</a>
						<span class="vline">|</span>
						<a href="/help/fuwuxieyi" class="c6">服务协议</a>
						<span class="vline">|</span>
						<a href="/help/falvshengming" class="c6">法律声明</a>
						<span class="vline">|</span>
						<a href="/help/yinsizhengce" class="c6">隐私权政策</a>
						<span class="vline">|</span>
						<a href="javascript:;" @click="company()" class="c6">公司简介</a>
						<span class="vline">|</span>
						<a href="/help/yingyezhizhao" class="c6">营业执照</a>
					</p>
				</div>
				<div style="text-align:center;">
					<p style="line-height:36px;"> Copyright © 2022 ICP备案:<a href="https://beian.miit.gov.cn" class="c9">粤ICP备16119259号-1</a></p>
					<p style="line-height:36px;">版权所有:广州华趣电子商贸有限公司</p>
					<p class="mt10">
						<a href="https://apps.apple.com/cr/app/%E5%A4%9C%E6%A8%B1%E6%83%85%E8%B6%A3-%E6%88%90%E4%BA%BA%E4%B8%A4%E6%80%A7%E6%83%85%E8%B6%A3%E7%94%A8%E5%93%81%E7%89%B9%E5%8D%96%E6%8A%98%E6%89%A3%E5%95%86%E5%9F%8E/id1556809706" target="_blank" title="夜樱情趣商城iPhone,ipad版" class="mr5">
							<img src="../assets/image/bottom/sf2.png" width="110" height="30">
						</a>
						<a href="https://appgallery.huawei.com/app/C103775707?sharePrepath=ag&locale=zh_CN&source=appshare&subsource=C103775707&shareTo=com.alibaba.android.rimet&shareFrom=appmarket" target="_blank" title="夜樱情趣商城Android版">
							<img src="../assets/image/bottom/sf3.png" width="110" height="30">
						</a>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default{
	data(){
		return{
			
		}
		
	},
	methods:{
		company(){
			//指定跳转地址
			this.$router.replace('/about')
		}
	}
}
</script>

<style scoped>
	*{
		margin:0;
		padding: 0;
	}
	#footer{
		border: 1px solid red;
		background-color: #dde4ea;
		margin-top: 0px;
		padding-top: 10px;
	}
	.content{
		border: 1px solid;
		/* width: 1200px; */
		text-align:center;
		margin: auto;
	}
	.f_dl{
		width: 200px;
	}
	.w{
		width: 1200px;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Footer1.vue